module.exports = __webpack_public_path__ + "static/media/unchecked.a270bb80.svg";